import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'

import 'vuesax/dist/vuesax.css' // Vuesax
import 'material-icons/iconfont/material-icons.css' //Material Icons

Vue.use(Vuesax)

// axios
import axios from "./axios.js"
Vue.prototype.$http = axios

// API Calls
import "./http/requests"

// mock
import "./fake-db/index.js"

// pusher
import './pusher'

// Theme Configurations
import '../themeConfig.js'

// Firebase
import '@/firebase/firebaseConfig'

// Auth0 Plugin
import AuthPlugin from "./plugins/auth"
Vue.use(AuthPlugin)

// Masks
import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

// Money Mask
import money from 'v-money'
Vue.use(money)

// ACL
import acl from './acl/acl'

// Globally Registered Components
import './globalComponents.js'

// Styles: SCSS
import './assets/scss/main.scss'

// Tailwind
import '@/assets/css/main.css'

// Vue Router
import router from './router'

// Vuex Store
import store from './store/store'

// i18n
import i18n from './i18n/i18n'

// Vuexy Admin Filters
import './filters/filters'

// Clipboard
Vue.use(VueClipboard)
import VueClipboard from 'vue-clipboard2'

// Tour
import VueTour from 'vue-tour'

require('vue-tour/dist/vue-tour.css')

Vue.use(VueTour)

// VeeValidate
import VeeValidate from 'vee-validate'
import messages from 'vee-validate/dist/locale/pt_BR'

// Merge the locales.
Vue.use(VeeValidate)
VeeValidate.Validator.localize('pt_BR', messages)

import _ from 'lodash'
Object.defineProperty(Vue.prototype, '$_', { value: _ })

// Google Maps
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
    load: {
        // Add your API key here
        key: 'YOUR_API_KEY',
        libraries: 'places' // This is required if you use the Auto complete plug-in
    }
})

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'

Vue.use(VueHammer)

// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

// Feather font icon
require('./assets/css/iconfont.css')

// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css'

Vue.config.productionTip = false

/**
 * Quill editor configs
 */
import Quill from 'quill'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'

// Quill styles
const StyleAlign = Quill.import('attributors/style/align')
Quill.register(StyleAlign, true)
const StyleBackground = Quill.import('attributors/style/background')
Quill.register(StyleBackground, true)
const StyleColor = Quill.import('attributors/style/color')
Quill.register(StyleColor, true)
const StyleDirection = Quill.import('attributors/style/direction')
Quill.register(StyleDirection, true)
const StyleFont = Quill.import('attributors/style/font')
Quill.register(StyleFont, true)
const StyleSize = Quill.import('attributors/style/size')
StyleSize.whitelist = ['14px', '16px', false, '18px']
Quill.register(StyleSize, true)

// Quill icons
const quillIcons = Quill.import('ui/icons')
quillIcons['audio'] = '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="volume-up" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" class="svg-inline--fa fa-volume-up fa-w-18 fa-2x"><path fill="currentColor" d="M215.03 71.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V88.02c0-21.46-25.96-31.98-40.97-16.97zm233.32-51.08c-11.17-7.33-26.18-4.24-33.51 6.95-7.34 11.17-4.22 26.18 6.95 33.51 66.27 43.49 105.82 116.6 105.82 195.58 0 78.98-39.55 152.09-105.82 195.58-11.17 7.32-14.29 22.34-6.95 33.5 7.04 10.71 21.93 14.56 33.51 6.95C528.27 439.58 576 351.33 576 256S528.27 72.43 448.35 19.97zM480 256c0-63.53-32.06-121.94-85.77-156.24-11.19-7.14-26.03-3.82-33.12 7.46s-3.78 26.21 7.41 33.36C408.27 165.97 432 209.11 432 256s-23.73 90.03-63.48 115.42c-11.19 7.14-14.5 22.07-7.41 33.36 6.51 10.36 21.12 15.14 33.12 7.46C447.94 377.94 480 319.54 480 256zm-141.77-76.87c-11.58-6.33-26.19-2.16-32.61 9.45-6.39 11.61-2.16 26.2 9.45 32.61C327.98 228.28 336 241.63 336 256c0 14.38-8.02 27.72-20.92 34.81-11.61 6.41-15.84 21-9.45 32.61 6.43 11.66 21.05 15.8 32.61 9.45 28.23-15.55 45.77-45 45.77-76.88s-17.54-61.32-45.78-76.86z" class=""></path></svg>'

// Quill Audio
const BlockEmbed = Quill.import('blots/block/embed');
class AudioBlot extends BlockEmbed {
  static create(url) {
    let node = super.create();
    node.setAttribute('src', url);
    node.setAttribute('controls', '');
    node.setAttribute('controlslist', 'nodownload');
    return node;
  }
  
  static value(node) {
    return node.getAttribute('src');
  }
}
AudioBlot.blotName = 'audio';
AudioBlot.tagName = 'audio';
Quill.register(AudioBlot);

// Quill Uploaded Video
class UploadedVideoBlot extends BlockEmbed {
  static create(url) {
    let node = super.create();
    node.setAttribute('src', url);
    node.setAttribute('controls', '');
    node.setAttribute('controlslist', 'nodownload');
    return node;
  }
  
  static value(node) {
    return node.getAttribute('src');
  }
}
UploadedVideoBlot.blotName = 'uploaded-video';
UploadedVideoBlot.tagName = 'video';
Quill.register(UploadedVideoBlot);

const vue = new Vue({
    router,
    store,
    i18n,
    acl,
    render: h => h(App)
}).$mount('#app')

export default vue
